import { toRaw } from 'vue';
import { injectTypes } from '@/Types/InjectTypes';
import { guid } from '@/Utils';

export default {
    inject: {
        injectedFieldId: {
            from: injectTypes.fieldId,
            default: null,
        },
    },
    provide() {
        return {
            [injectTypes.fieldId]: this.fieldId,
        };
    },
    props: {
        id: { default: null, type: String },
        disabled: { default: false, type: Boolean },
        name: { default: null, type: String },
        placeholder: { default: null, type: [String, Number, Boolean] },
        readOnly: { default: false, type: Boolean },
        small: { default: false, type: Boolean },
        modelValue: {},
    },
    emits: ['update:modelValue', 'blur', 'focus', 'keydown'],
    data () {
        return {
            model: this.modelValue,
            localId: guid(),
        };
    },
    computed: {
        fieldId() {
            return this.id || this.name || this.injectedFieldId || this.localId;
        },
    },
    methods: {
        focus() {
            if (this.$refs.input) {
                this.$refs.input.focus.apply(this.$refs.input);
            }
        },
        onBlur(evt) {
            this.$emit('blur', evt);
        },
        onFocus(evt) {
            this.$emit('focus', evt);
        },
        onKeydown(evt) {
            this.$emit('keydown', evt);
        },
    },
    watch: {
        'model' (newValue) {
            // Compare raw values. Reading data 'model' yields a reactive proxy while the
            // 'modelValue' prop is the raw object, so a plain !== is always true for
            // reference types and would emit on every change, looping when the parent
            // re-derives modelValue each render.
            if (toRaw(newValue) !== toRaw(this.modelValue)) {
                this.$emit('update:modelValue', newValue);
            }
        },
        'modelValue' (newValue) {
            this.model = newValue;
        },
    },
};
